import qs from 'query-string';
import ApiClientInstance, { CLIENT_ID } from '../common/ApiClient';
import { getCallbackUrl, startSession } from '../common/authSession';

export const generateAuthorizeURL = (serviceName, state) => {
  const params = {
    client_id: CLIENT_ID,
    screen: 'signup',
    service: serviceName || undefined,
    redirect_uri: getCallbackUrl(),
    state,
  };
  return `${ApiClientInstance.authUrl}/authorize?${qs.stringify(params)}`;
};

// A tab draining the old flow arrives with a dead code in the url; it must not be kept.
const currentEntryPath = () => {
  const { pathname, search, hash } = window.location;
  const params = qs.parse(search);
  delete params.code;
  delete params.state;
  const query = qs.stringify(params);
  return `${pathname}${query ? `?${query}` : ''}${hash}`;
};

export const login = (serviceName, entryPath) => {
  const state = startSession(entryPath || currentEntryPath());
  window.location.href = generateAuthorizeURL(serviceName, state);
};
